import { proxy, snapshot } from "valtio";

const appState = proxy({
  firstStep: "",
  shouldCutInformedBeforehandStep: false,
});

export function setFirstStep(stepName: string) {
  appState.firstStep = stepName;
}

export function isFirstStep(stepName: string | undefined) {
  if (!stepName) return;
  return snapshot(appState).firstStep === stepName;
}

export function setShouldCutInformedBeforehandStep() {
  appState.shouldCutInformedBeforehandStep = true;
}

export function getShouldCutInformedBeforehandStep() {
  return snapshot(appState).shouldCutInformedBeforehandStep;
}
